import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { TeacherActivity } from '../../../../core/services/http/dashboard/interfaces/teacher-activity';
import { User } from '../../../../core/services/http/user/interfaces/user';
import { EmployeeActivityInfoModalComponent } from './employee-activity-info-modal/employee-activity-info-modal.component';

@Component({
  selector: 'app-employee-activity-data-list',
  templateUrl: './employee-activity-data-list.component.html',
  styleUrls: ['./employee-activity-data-list.component.scss']
})
export class EmployeeActivityDataListComponent extends DestroyNotifierComponent implements OnChanges {
  @Input() user: User | undefined;
  @Input() activities: TeacherActivity[] | undefined;

  hasActivities = false;

  constructor(private modalService: BsModalService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activities == null || changes.activities.currentValue === null || changes.activities.currentValue.length === 0) {
      this.hasActivities = false;
    } else {
      this.hasActivities = true;
    }
  }

  async onOpenActivityInfo(teacherActivity: TeacherActivity): Promise<void> {
    const initialState = {
      teacherActivity,
      teacher: this.user
    };

    this.modalService.show(EmployeeActivityInfoModalComponent, { initialState });
  }
}
